(function () {
  'use strict';

  var priceCache = new Map();
  var renderTimer;

  function formatMoney(cents) {
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      return window.theme.formatMoney(cents);
    }

    return (cents / 100).toFixed(2);
  }

  function getProductPriceUrl(card) {
    var productLink = card.matches && card.matches('a[href*="/products/"]') ? card : card.querySelector('a[href*="/products/"]') || card.closest('a[href*="/products/"]');
    var productUrl = productLink ? productLink.href : card.dataset.productUrl;
    if (!productUrl) return null;

    var url = new URL(productUrl, window.location.origin);
    url.hash = '';
    url.searchParams.set('view', 'eq-custom-price');
    return url.href;
  }

  function fetchPrices(url) {
    if (!priceCache.has(url)) {
      priceCache.set(url, fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to load product tax price');
          return response.json();
        })
        .catch(function () {
          priceCache.delete(url);
          return null;
        }));
    }

    return priceCache.get(url);
  }

  function updateStandardCard(card, prices) {
    var price = card.querySelector('.price');
    if (!price) return;

    var amount = price.querySelector('.amount');
    if (amount) amount.innerHTML = formatMoney(Number(prices.priceToShow));

    var comparePrice = Number(prices.compareAtPriceToShow);
    var currentPrice = Number(prices.priceToShow);
    var compare = price.querySelector('del');

    if (comparePrice > currentPrice) {
      if (!compare) {
        compare = document.createElement('del');
        compare.innerHTML = '<span class="theme-money"></span>';
        price.appendChild(compare);
      }
      compare.querySelector('.theme-money').innerHTML = formatMoney(comparePrice);
      price.classList.add('on-sale');
    } else if (compare) {
      compare.remove();
      price.classList.remove('on-sale');
    }
  }

  function updateSearchCard(card, prices) {
    var searchPrice = card.matches && card.matches('.gl-card-price, span.gf-search-item-product') ? card : card.querySelector('.gl-card-price, span.gf-search-item-product');
    if (searchPrice) searchPrice.innerHTML = formatMoney(Number(prices.priceToShow));
  }

  function updateUsfCard(card, prices) {
    var price = card.querySelector('.usf-price');
    if (!price) return;

    var currentPrice = Number(prices.priceToShow);
    var comparePrice = Number(prices.compareAtPriceToShow);
    var isOnSale = comparePrice > currentPrice;
    var discount = card.querySelector('.usf-discount');

    price.innerHTML = formatMoney(isOnSale ? comparePrice : currentPrice);
    price.classList.toggle('usf-has-discount', isOnSale);

    if (isOnSale) {
      if (!discount) {
        discount = document.createElement('span');
        discount.className = 'usf-discount';
        price.insertAdjacentElement('afterend', discount);
      }
      discount.innerHTML = formatMoney(currentPrice);
    } else if (discount) {
      discount.remove();
    }
  }

  function updateCard(card) {
    if (card.dataset.taxPriceLoaded === 'true') return;

    var priceUrl = getProductPriceUrl(card);
    if (!priceUrl) return;

    card.dataset.taxPriceLoaded = 'true';
    fetchPrices(priceUrl).then(function (prices) {
      if (!prices) {
        card.dataset.taxPriceLoaded = '';
        return;
      }

      updateStandardCard(card, prices);
      updateSearchCard(card, prices);
      updateUsfCard(card, prices);
    });
  }

  function updateCards() {
    document.querySelectorAll('[data-globo-filter-items] .product-block, .gl-card, .gf-search-item-product, .usf-sr-product, .usf-is-product').forEach(updateCard);
  }

  function scheduleUpdate() {
    clearTimeout(renderTimer);
    renderTimer = setTimeout(updateCards, 50);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleUpdate();
    new MutationObserver(scheduleUpdate).observe(document.body, { childList: true, subtree: true });
  });
  window.addEventListener('globoFilterRenderCompleted', scheduleUpdate);
}());
